import { Dispatch } from 'react-redux';

import { removeAlertAction } from '../../app/actions/RemoveAlertAction';
import { updateAlertsAction } from '../../app/actions/UpdateAlertsAction';
import { updateAlertTotalAction } from '../../app/actions/UpdateAlertTotalAction';
import { DataSources } from '../../datasource/resources/Datasources';
import { Alerts } from '../../dda/resources/Alerts';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { IAlertInfo, IAlertListInfo } from '../../ts/models/IAlertInfo';
import { Workbooks } from '../../workbook/resources/Workbooks';

export class AlertActions {

  constructor(private dispatch: Dispatch<unknown>) { }

  public getAlertCount() {
    Alerts.getCount().then((count: number) => {
      this.dispatch(updateAlertTotalAction(count));
    });
  }

  public getAlerts() {
    Alerts.getList().then((alertListInfo: IAlertListInfo) => {
      this.dispatch(updateAlertsAction(alertListInfo));
    });
  }

  public tryAgain(alert: IAlertInfo) {
    const taskId = alert.taskId;
    const extractType = alert.alertType; // either 'IncrementExtract' or 'RefreshExtract'.

    if(taskId) {
      // run extract task by ID
      ExtractTasks.run([taskId]).then(() => this.getAlerts());
    } else if (extractType) {
      // if we don't have a task ID,
      // we may need to run a datasource or workbook refresh by the item ID & refresh type.
      // if datasourceId is present, the alert item is a datasource.
      // if datasourceId is not present, the alert item is a workbook with ID affectedWorkbookIds[0].
      const datasourceId = alert.datasource && alert.datasource.id;
      const workbookId = alert.workbooks && alert.workbooks[0] && alert.workbooks[0].id;
      if (datasourceId) {
        // refresh datasource
        DataSources.refreshExtracts([datasourceId], extractType).then(() => () => this.getAlerts());
      } else if (workbookId) {
        // refresh workbook
        Workbooks.refreshExtracts([workbookId], extractType).then(() => () => this.getAlerts());
      }
    }

    this.dispatch(removeAlertAction(alert.id));
  }

}
